import { ListData } from '../List/types'

export enum ListItemType {
  DEFAULT = 'DEFAULT',
  SIDE_MENU = 'SIDE_MENU',
  TABLE = 'TABLE',
  MENU_TITLE = 'MENU_TITLE',
  NOTIFICATION = 'NOTIFICATION',
  MODES = 'Modes',
  BLOCK = 'Block',
  SEARCH = 'SEARCH',
  EXPORT = 'EXPORT',
  CALENDAR = 'CALENDAR',
  SEARCH_FILTERS = 'SEARCH_FILTERS',
  INVOICE = 'INVOICE',
}

export enum ListTypes {
  DEFAULT = 'DEFAULT',
  SIDE_MENU = 'SIDE_MENU',
  MENU_TITLE = 'MENU_TITLE',
  NOTIFICATION = 'NOTIFICATION',
  MODES = 'Modes',
  SEARCH = 'SEARCH',
  EXPORT = 'EXPORT',
  CALENDAR = 'CALENDAR',
  SEARCH_FILTERS = 'SEARCH_FILTERS',
  INVOICE = 'INVOICE',
}
export interface ListItemProps {
  type: ListTypes
  data: ListData
  selected?: boolean
  onPress?: () => void
  showHideSubMenu?: (showHide: boolean, parentId: string) => void
}

export interface ListItemEntry {
  id: string
  value: string
  index: string
}
